// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.H4U6MH7rK_nS2t {
  margin: var(--ds-space-0, 0) var(--ds-space-0, 0) var(--ds-space-0, 0);
  background-color: var(--dynamic-nav-item-interactable);
  color: var(--dynamic-text);
}
.H4U6MH7rK_nS2t:hover {
  background-color: var(--dynamic-nav-item-interactable-hovered);
  color: var(--dynamic-text);
}
.H4U6MH7rK_nS2t:active {
  background-color: var(--dynamic-nav-item-interactable-pressed);
  color: var(--dynamic-text);
}
.H4U6MH7rK_nS2t.nBNw1r5G2nCQUZ {
  color: var(--dynamic-text);
  background-color: var(--dynamic-button-highlighted);
  color: var(--dynamic-button-highlighted-text);
}
.H4U6MH7rK_nS2t.nBNw1r5G2nCQUZ svg circle {
  stroke: var(--dynamic-icon);
}
.H4U6MH7rK_nS2t.nBNw1r5G2nCQUZ:hover {
  background: var(--dynamic-button-highlighted-hovered);
  color: var(--dynamic-button-highlighted-text);
}
.Gbml1Qtt63h8qH {
  background-color: var(--ds-background-neutral, #091e420f);
}
html[data-color-mode='dark'] .Gbml1Qtt63h8qH {
  background-color: var(--ds-background-neutral-subtle-hovered, #a1bdd914);
}
.Gbml1Qtt63h8qH:hover {
  background-color: var(--ds-background-neutral-hovered, #091e4224);
}
html[data-color-mode='dark'] .Gbml1Qtt63h8qH:hover {
  background-color: var(--ds-background-neutral-hovered, #A6C5E229);
}
.Gbml1Qtt63h8qH:active {
  background: var(--ds-background-neutral-pressed, #091e424f);
}
html[data-color-mode='dark'] .Gbml1Qtt63h8qH:active {
  background-color: var(--ds-background-neutral-hovered, #A6C5E229);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"joinButton": `H4U6MH7rK_nS2t`,
	"highlighted": `nBNw1r5G2nCQUZ`,
	"joinButtonHomePage": `Gbml1Qtt63h8qH`
};
export default ___CSS_LOADER_EXPORT___;
